import script from "./VirtualConference.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualConference.vue?vue&type=script&setup=true&lang=js"

import "./VirtualConference.vue?vue&type=style&index=0&id=368f5418&lang=css"

const __exports__ = script;

export default __exports__